module.exports = __webpack_public_path__ + "img/cards-checked.47d7f182.svg";